module.exports = __webpack_public_path__ + "img/2icono_signature.10e566ca.svg";